import React from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";

/*
    props
    error_msg : string
 */
const ErrorMsg = (props) => {
    // css style
    const {view} = useComponentStyle();

    return <view.ErrorMsgFiled>{props.error_msg}</view.ErrorMsgFiled>;
};

export default ErrorMsg;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        view: {
            ErrorMsgFiled: styled.span({
                color: "red",
                fontSize: theme.font_size.f14,
            }),
        },
    };
};
